module.exports = __webpack_public_path__ + "img/tr_tr.bced995d.png";